// extracted by mini-css-extract-plugin
export default {"form-block":"form-block","formBlock":"form-block","form-block-padded":"form-block-padded","formBlockPadded":"form-block-padded"};